import { render, staticRenderFns } from "./AddWork.vue?vue&type=template&id=a006e464&scoped=true&"
import script from "./AddWork.vue?vue&type=script&lang=js&"
export * from "./AddWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a006e464",
  null
  
)

export default component.exports